import React, { useEffect, useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '../../../../store';
import { ILocalize } from 'features/common/types';
import { DLocalTitularForm } from '../DLocalTitularForm';
import { buildDLocalTitularDefaults } from 'features/transaction-details/helpers/buildDLocalTitularDefaults';

export interface DLocalPaymentOrderProps {
	clientLocation: ILocalize | null;
	countryCode: string;
}

export const DLocalClientTransaction = ({
	clientLocation,
	countryCode,
}: DLocalPaymentOrderProps): JSX.Element | null => {
	const { payment } = useSelector((state: RootState) => state);
	const [defaultsKey, setDefaultsKey] = useState(0);

	const orderData = payment.orderDataToClient;

	const defaultValues = useMemo(() => {
		if (!orderData) return null;
		return buildDLocalTitularDefaults(orderData, null, '', '', clientLocation);
	}, [orderData, clientLocation, defaultsKey]);

	useEffect(() => {
		if (orderData) {
			setDefaultsKey((k) => k + 1);
		}
	}, [clientLocation, orderData?.orderId]);

	if (!orderData || !defaultValues) {
		return null;
	}

	return (
		<DLocalTitularForm
			orderData={orderData}
			clientLocation={clientLocation}
			countryCode={countryCode}
			defaultValues={defaultValues}
			redirectTarget="same_tab"
			showOrderSummary
		/>
	);
};
